import React from 'react';

interface ToastActionButtonProps {
  actionText?: string;
  onAction?: () => void;
  className: string;
}

const ToastActionButton: React.FC<ToastActionButtonProps> = ({
  actionText,
  onAction,
  className,
}) => {
  if (!actionText) return null;

  return (
    <button className={className} onClick={onAction}>
      {actionText}
    </button>
  );
};

export default ToastActionButton;
